module.exports = __webpack_public_path__ + "static/visual_2-ee3cc9facc31e37d2fc910daff33ede5.jpg";